import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { get } from "lodash";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";
import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";
import { CONSUMER, applicationTypes } from "common/constant";

const OtherApplicationExtraFieldsView = ({
  extraValues,
  isExpandable = true,
  t,
}) => {
  const { roles } = useSelector((state) => state.Login);

  const {
    applicationType: { id: applicationTypeId },
    totalBuildupArea,
    totalNumberOfOccupants,
    totalBuildupAreaUnit,
    totalNumberOfOccupantsUnit,
  } = extraValues;
  const fields = useMemo(
    () => [
      {
        name: "Total Build Up Area",
        key: "totalBuildupArea",
        isRequired: true,
        renderField: () =>
          totalBuildupArea
            ? `${totalBuildupArea} ${getOptionLabel(
                "unitOptions",
                totalBuildupAreaUnit
              )}`
            : "N/A",
      },
      {
        name: "Total Number Of Occupants",
        key: "totalNumberOfOccupants",
        renderField: () =>
          totalNumberOfOccupants
            ? `${totalNumberOfOccupants} ${getOptionLabel(
                "unitOptions",
                totalNumberOfOccupantsUnit
              )}`
            : "N/A",

        isRequired: true,
      },
      {
        name: "Connection Start Date",
        key: "expectedConnectionStartDate",
        isVisible:
          applicationTypeId === applicationTypes["Temporary Connection"],
        isRequired:
          applicationTypeId === applicationTypes["Temporary Connection"],
        renderField: (value) =>
          value ? convertUTCDateToLocalDate(value).format("DD-MM-YYYY") : "-",
      },
      {
        name: "Connection End Date",
        key: "expectedConnectionEndDate",
        isVisible:
          applicationTypeId === applicationTypes["Temporary Connection"],
        isRequired:
          applicationTypeId === applicationTypes["Temporary Connection"],
        renderField: (value) =>
          value ? convertUTCDateToLocalDate(value).format("DD-MM-YYYY") : "-",
      },
      {
        name: "Tariff",
        key: "tariff.name",
        isVisible: !roles.includes(CONSUMER),
        isRequired: true,
      },
    ],
    [extraValues]
  );

  return (
    <Collapse title="Area And Occupancy Details" isExpandable={isExpandable}>
      <Row className="d-flex mb-2">
        {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
          const value = get(extraValues, key, "");
          if (typeof isVisible !== "boolean" || isVisible) {
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(extraValues, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          }
          return <Fragment key={key} />;
        })}
      </Row>
    </Collapse>
  );
};

OtherApplicationExtraFieldsView.propTypes = {
  isExpandable: PropTypes.bool,
  extraValues: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(OtherApplicationExtraFieldsView);
